"use strict";

const DEFAULT_MOTIF = "light";
const colors = {
  menu: {
    base: {
      light: "#FFFFFF",
      dark: "#000000"
    },
    transparent: {
      light: "rgba(255 255 255 / 0.6)",
      dark: "rgba(0 0 0 / 0.6)"
    },
    baseAccent: {
      light: "#E5E5E5",
      dark: "#2D2D2D"
    },
    text: {
      light: "#393939",
      dark: "#FFFFFF"
    },
    textAccent: {
      light: "#8A8A8B",
      dark: "#8A8A8B"
    },
    active: {
      light: "#006FFF",
      dark: "#006FFF"
    },
    categoryIcon: {
      light: "#4D4D4D",
      dark: "#8E8E8E"
    },
    categoryIconActive: {
      light: "#1D1D1F",
      dark: "#FFFFFF"
    },
    mobileMenu: {
      light: "#FFFFFF",
      dark: "#1B1B1B"
    },
    mobileMenuAccent: {
      light: "#EDEDF0",
      dark: "#2D2D2D"
    },
    mobileMenuText: {
      light: "rgba(0 0 0 / 0.65)",
      dark: "#F6F6F8"
    },
    mobileMenuItem: {
      light: "#F6F6F8",
      dark: "#1B1B1B"
    },
    mobileMenuActive: {
      light: "#FAFBFB",
      dark: "#121212"
    },
    modal: {
      light: "#FFFFFF",
      dark: "#FFFFFF"
    },
    modalActiveItem: {
      light: "#F5F5F5",
      dark: "#F5F5F5"
    },
    cartModal: {
      light: "#FFFFFF",
      dark: "#3F4148"
    },
    cartModalText: {
      light: "#36373C",
      dark: "#FFFFFF"
    },
    micrositeSubMenuText: {
      light: "#36373C",
      dark: "#CDD1D5"
    },
    proSubMenuText: {
      light: "#50565E",
      dark: "#CDD1D5"
    }
  },
  alabaste: "#FBFBFB",
  aliceBlue: "#F2F8FF",
  aluminium: "#A4A7B5",
  anakiwa: "#99C5FF",
  sonicSilver: "#757575",
  vulcan: "#393A3F",
  athensGreyDark: "#EDEDF0",
  athensGreyLight: "#F6F6F8",
  athensGreyLight65: "#F6F6F8A6",
  weatheredStone: "#c4c4c4",
  black: "#000000",
  black10: "rgba(0, 0, 0, 0.10)",
  black20: "rgba(0, 0, 0, 0.20)",
  black25: "rgba(0, 0, 0, 0.25)",
  black45: "rgba(0, 0, 0, 0.45)",
  black50: "rgba(0, 0, 0, 0.50)",
  black65: "rgba(0, 0, 0, 0.65)",
  black85: "rgba(0, 0, 0, 0.85)",
  blackOrchid: "#525461",
  shuttleGray: "#6B6D76",
  blackHaze: "#FAFBFB",
  buttercup: "#F5A623",
  codGrey: "#0E0E0E",
  cornFlower: "#5C98E6",
  cornFlower10: "rgba(0, 111, 255, 0.10)",
  cornFlower20: "rgba(0, 111, 255, 0.20)",
  cornFlower30: "rgba(0, 111, 255, 0.30)",
  dodgerblue: "#338CFF",
  geebung: "#C4851C",
  emerald: "#39CC64",
  ghost: "#C8CAD3",
  grey45: "rgba(0, 0, 0, 0.45);",
  greySuit: "#BDBFCC",
  magnolia: "#FCFBFF",
  mediumPurple: "#A252E3",
  mischka: "#DBDCE1",
  mischka50: "#DBDCE180",
  offYellow: "#FEF6E9",
  pattensBlue: "#D3E6FF",
  pomegranate: "#F03A3E",
  sunsetOrange: "#FF4E52",
  primaryBlue: "#006FFF",
  primaryBlue90: "#006FFFE6",
  seaGreen: "#2EA350",
  selago: "#F6EEFC",
  shark: "#212124;",
  smalt: "#003C9E",
  tara: "#EBFAEF",
  solitude: "#E5F1FF",
  waterloo: "#838691",
  woodsmoke: "#141415",
  whisper: "#faf9fb",
  white: "#FFFFFF",
  whiteLilac: "#F8F9FD",
  desktopNeutral1: "#F9F9FA",
  desktopNeutral2: "#f4f5f6",
  desktopNeutral3: "#EEEFF1",
  desktopNeutral12: "#212427"
};
const fontFamily = {
  default: '"UI Sans", Lato, HelveticaNeue, "Helvetica Neue", Helvetica, Arial, sans-serif'
};
const fontSizes = {
  size9: "9px",
  size10: "10px",
  size11: "11px",
  size12: "12px",
  size13: "13px",
  size14: "14px",
  size15: "15px",
  size16: "16px",
  size17: "17px",
  size18: "18px",
  size20: "20px",
  size21: "21px",
  size22: "22px",
  size24: "24px",
  size26: "26px",
  size28: "28px",
  size32: "32px",
  size36: "36px",
  size38: "38px"
};
const fontWeights = {
  regular: "400",
  medium: "500",
  bold: "700"
};
const lineHeights = {
  // Old discounted
  size16: "16px",
  size18: "18px",
  size20: "20px",
  size22: "22px",
  size24: "24px",
  size26: "26px",
  size28: "28px",
  size30: "30px",
  size36: "36px",
  size38: "38px",
  size44: "44px",
  // New way
  title: 1.16,
  header: 1.4,
  subHeader: 1.5,
  text: 1.7,
  keyFeatures: 1.42
};
const zIndexes = {
  toast: 10500,
  popover: 10400,
  modal: 1e4,
  modalUnderlay: 9995,
  dropDown: 9500,
  header: 9e3,
  searchOverlay: 8995,
  mobileMenu: 8990,
  cartSummary: 8500
};
const theme = {
  colors,
  font: fontSizes,
  fontFamily,
  fontWeight: fontWeights,
  lineHeight: lineHeights,
  zIndex: zIndexes,
  header: {
    color: colors.black65,
    size: fontSizes.size14,
    lineHeight: lineHeights.size24
  }
};
export { DEFAULT_MOTIF, theme };
//# sourceMappingURL=theme.mjs.map
